<app-header />
<div class="bg_2">
    <div class="pr_detail_top bg_1 inline_padding1 p-top-132">
        <div class="pr_detail_top_flex dis-flex-7 ">
            <div class="text_blue_5 p-y-18 cursor-pointer" [routerLink]="['/']">
                <a>Home</a>
            </div>
            <div class="p-l-16 p-y-18">
                <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
                        fill="#303030" />
                </svg>
            </div>
            <div class="text_blue_5 p-l-16 p-y-18 cursor-pointer" [routerLink]="['/profile']">
                <a>My Profile</a>
            </div>
            <div class="p-l-16 p-y-18">
                <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
                        fill="#303030" />
                </svg>
            </div>
            <div class="text_black_8 p-l-16 p-y-18">
                <span>Settings</span>
            </div>
        </div>
    </div>
    <div class="edit ">
        <div *ngIf="alertVisible" class="alert alert-success alert-dismissible fade show" role="alert">
            <strong>Success!</strong> Your profile has been updated successfully.
            <button type="button" class="btn-close" (click)="closeAlert()"></button>
          </div>
        <div class="edit_body p-top-40">
            <div class="edit_body_heading width-100-per border_right_blue">
                <div class="width-100-per">
                    <div class="cursor-pointer right-border-3 m-r-3-neg">
                        <div class="p-y-18">
                            <span class="text_blue_17">Edit Profile</span>
                        </div>
                    </div>
                    <div class="cursor-pointer" [routerLink]="['/change_password']">
                        <div class="p-y-18">
                            <span class="text_black_13">Change Password</span>
                        </div>
                    </div>
                    <div data-bs-toggle="modal" data-bs-target="#signOutModal" class="cursor-pointer">
                        <div class="p-y-18">
                            <span class="text_black_13 p-top-48">Sign Out</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="edit_body_inner" *ngIf="form_initialised">
                <form [formGroup]="profileForm" (ngSubmit)="submit_profile_form()">
                    <div class=" bottom_padding1 edit_body_inner_input">
                        <div class=" bottom-border-1 width-100-per edit_body_inner_input_head">
                            <div class=" edit_body_inner_input_head_upper">
                                <div class="bottom-border-2 m-b-3">
                                    <span class="text_black_10  ">Personal Detail</span>
                                </div>
                                <div class="p-bot-5 edit_body_inner_input_head_upper_btn1">
                                    <button class="text_style_3 button_yellow_2" type="submit">Update</button>
                                </div>
                            </div>
                        </div>
                        <div class="dis-grid-2 edit_body_inner_input_box1">
                            <div class="dis-block-1 p-top-18">
                                <label for="firstName" class="dis-flex-4 text_grey_2">First Name</label>
                                <input type="text" id="firstName" formControlName="name"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                    placeholder="Enter Name" required>
                            </div>
                            <div class="dis-block-1 p-top-18">
                                <label for="email" class="dis-flex-4 text_grey_2">Email</label>
                                <input type="email" id="email" formControlName="email"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                    placeholder="Enter Email" required>
                            </div>
                            <div class="dis-block-1 p-top-18">
                                <label for="mobile" class="dis-flex-4 text_grey_2">Mobile</label>
                                <input type="tel" id="mobile" formControlName="mobile"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                    placeholder="Enter Mobile" required>
                            </div>
                            <div class="dis-block-1 p-top-18">
                                <label for="education" class="dis-flex-4 text_grey_2">Education</label>
                                <input type="text" id="education" formControlName="education"
                                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                    placeholder="Enter Education" required>
                            </div>
                        </div>
                        <div class="p-top-48 edit_body_inner_input_box2">
                            <div class=" bottom-border-1 width-100-per">
                                <div class="dis-flex-8">
                                    <div class="bottom-border-2 m-b-3">
                                        <span class="text_black_10  ">Professional Detail</span>
                                    </div>
                                </div>
                            </div>
                            <div class=" edit_body_inner_input_box2_data1 ">
                                <div class="dis-block-1 p-top-18">
                                    <label for="affiliation" class="dis-flex-4 text_grey_2">Institute/Company
                                        Affiliation</label>
                                    <input type="text" id="affiliation" formControlName="institute_company"
                                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                        placeholder="Enter Institute/Company Affiliation" required>
                                </div>
                                <div class="p-top-18">
                                    <label for="department" class="dis-flex-4 text_grey_2">Name of
                                        Department/Business Verticals</label>
                                    <input type="text" id="department" formControlName="department_name"
                                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                        placeholder="Enter Name of Department/Business Verticals" required>
                                </div>
                                <div class="p-top-18">
                                    <label for="companyEmail" class="dis-flex-4 text_grey_2">Company Email
                                        ID</label>
                                    <input type="email" id="companyEmail" formControlName="company_email_id"
                                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                        placeholder="Enter Company Email ID" required>
                                </div>
                                <div class="p-top-18">
                                    <label for="industry" class="dis-flex-4 text_grey_2">Industry</label>
                                    <input type="text" id="industry" required formControlName="industry"
                                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                        placeholder="Enter Industry" required>
                                </div>
                                <div class="p-top-18">
                                    <label for="companyName" class="dis-flex-4 text_grey_2">Company
                                        Name</label>
                                    <input type="text" id="companyName" formControlName="company_name"
                                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                        placeholder="Enter Company Name" required>
                                </div>
                                <div class="p-top-18">
                                    <label for="occupation" class="dis-flex-4 text_grey_2">Occupation</label>
                                    <input type="text" id="occupation" formControlName="occupation"
                                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                        placeholder="Enter Occupation" required>
                                </div>
                            </div>
                            <div>
                                <div class="text_align p-top-18 ">
                                    <span class="text_black_14">Company Address</span>
                                </div>
                                <div class=" edit_body_inner_input_box2_data2">
                                    <div class="p-top-18">
                                        <label for="country" class="dis-flex-4 text_grey_2">Country</label>
                                        <input type="text" id="country" formControlName="country_name"
                                            class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                            placeholder="Select Country" required>
                                    </div>
                                    <div class="p-top-18">
                                        <label for="state" class="dis-flex-4 text_grey_2">State</label>
                                        <input type="text" id="state" formControlName="state"
                                            class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                            placeholder="Enter State" required>
                                    </div>
                                    <div class="p-top-18">
                                        <label for="addressLine" class="dis-flex-4 text_grey_2">Address
                                            Line</label>
                                        <input type="text" id="addressLine" formControlName="address"
                                            class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                            placeholder="Enter Address Line" required>
                                    </div>
                                    <div class="p-top-18">
                                        <label for="pinCode" class="dis-flex-4 text_grey_2">PIN Code</label>
                                        <input type="text" id="pinCode" formControlName="pincode"
                                            class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-90-per p-x-15"
                                            placeholder="PIN Code" required>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-top-48">
                            <div class=" bottom-border-1 width-100-per">
                                <div class="dis-flex-8">
                                    <div class="bottom-border-2 m-b-3">
                                        <span class="text_black_10  ">Profession</span>
                                    </div>
                                    <!-- <div class="p-bot-5">
                                                    <button class="text_style_3 button_yellow_2"
                                                        [disabled]>Update</button>
                                                </div> -->
                                </div>
                            </div>
                            <div class="dis-flex-7 flex-wrap p-top-24">
                                <ng-container *ngFor="let profession of professions; let i = index">
                                    <div class="p-x-25 p-y-11 dis-flex-4 border_blue_1 border-radius-22 m-r-16 m-b-16"
                                         [ngClass]="{'bg_1': !profession.checked, 'bg_3': profession.checked, 'text_blue_5': !profession.checked, 'text_white_9': profession.checked}">
                                      <input type="checkbox" id="checkbox{{ i }}" name="checkbox{{ i }}" (change)="toggleCheckbox(i)" [checked]="profession.checked">
                                      <label for="checkbox{{ i }}" class="p-l-10">{{ profession.profession }}</label>
                                    </div>
                                  </ng-container>
                                  
                                  
                            </div>
                        </div>
                        <div class=" edit_body_inner_input_btn2">
                            <button class="text_style_3 button_yellow_2" type="submit">Update</button>
                        </div>
                    </div>
                    <!-- sign out -->
                    <div class="edit_body_inner_signout modal fade bg_4" id="signOutModal" tabindex="-1"
                        aria-labelledby="signOutModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered custom-modal-dialog">
                            <div class="modal-content dis-flex-2 edit_body_inner_signout_screen">
                                <div class="bottom-border-1 width-100-per  edit_body_inner_signout_screen_top">
                                    <div class="p-x-40 dis-flex-1 ">
                                        <span class="text_blue_11">
                                            Sign Out
                                        </span>
                                    </div>
                                </div>
                                <div class="p-top-40 ">
                                    <div class=" p-x-50">
                                        <span class="text_style_1">Are you sure you want to sign out? Any unsaved
                                            changes
                                            will be lost.</span>
                                    </div>
                                </div>
                                <div class=" edit_body_inner_signout_screen_btn">
                                    <button
                                        class="text_blue_4 button_white_5 edit_body_inner_signout_screen_btn_box" (click)="LogoutClick()">Sign
                                        Out</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</div>
<app-footer />

  